import jQuery from 'jquery';

function submitContactForm(form) {
    const url = form.attr('action');
    const method = form.attr('method');
    const formData = form.serialize();
    const submitButtonSelector = form.find('button[type="submit"]');

    toggleButton(submitButtonSelector, true);

    form.parent().find('.result.success').slideUp();
    form.find('.result.error').slideUp();

    jQuery.ajax({
        type: method || 'POST',
        url,
        data: formData,
    }).done(() => {
        form.slideUp();
        form.parent().find('.result.success').slideDown();
        toggleButton(submitButtonSelector, false);

        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery('.contact-form-pp').offset().top,
        }, 400);
    }).fail(() => {
        form.find('.result.error').slideDown();
        toggleButton(submitButtonSelector, false);
    });
}

function toggleButton($button, loading) {
    if (loading) {
        jQuery($button).addClass('loading');
    } else {
        jQuery($button).removeClass('loading');
    }
    jQuery($button).prop('disabled', loading);
}

export default function contactForm() {
    const formSelector = jQuery('#contact_form');
    formSelector.on('submit', (e) => {
        e.preventDefault();
        submitContactForm(jQuery(formSelector));
    });
}
